<template>
  <div id="container" class="cs_st grid-container">
    <!-- Location START -->
    <!-- TODO: Should be a component. Sidebar will automatically switch to different menu items when it is active on any help page  -->
    <Sidebar />
    <BaseLocation current-group-name="serviceCenter" />
    <!-- Location END -->
    <div class="section fill">
      <div class="inner">
        <h2>{{ $t('views.help.notices.4219') }}</h2>
        <p class="sub">{{ $t('views.help.notices.5428') }}</p>
        <div class="notice">
          <ul class="list">
            <li
              v-for="(notice, idx) in getStoreAnnouncements"
              :key="idx"
              :class="{ active: idx === selected }"
              :tabindex="isNiaMode ? 0 : false"
              @click="expandNotice(idx)"
              @keypress="expandNotice(idx)"
            >
              <div class="tit">
                <span class="cat info">안내</span>
                <p class="txt">
                  {{ notice.title }}
                </p>
                <span class="num date">{{ notice.noticeDate | date }}</span>
              </div>
              <div class="cont">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="txt" v-html="notice.noticeDesc"></div>
              </div>
            </li>
          </ul>

          <Pagination
            :current-page="currentPage"
            :total-count="getStoreAnnouncementTotalCount"
            :item-per-page="noticesPerPage"
            @paginate="paginate"
          />
        </div>
      </div>
    </div>
    <transition name="slide-right">
      <Sidebar v-show="isSidebarOpen" />
    </transition>
  </div>
</template>

<script>
import { STORE_ANNOUNCEMENT_GET_LIST, UI_SHOW_SIDEBAR } from '@/store/types'
import { isNiaMode } from '@/store/constants'
import { mapGetters } from 'vuex'
import BaseLocation from '../../components/base/BaseLocation.vue'
import Sidebar from '../../components/library/Sidebar.vue'

export default {
  name: 'Notices',
  components: { BaseLocation, Sidebar },

  data() {
    return {
      showListMenu: false,
      selected: null,
      currentPage: 1,
      noticesPerPage: 10,
      isNiaMode
    }
  },
  computed: {
    ...mapGetters([
      'isStoreAnnouncementLoading',
      'getStoreAnnouncements',
      'getStoreAnnouncementTotalCount',
      'isSidebarOpen'
    ])
  },
  mounted() {
    this.loadAnnouncements()
  },
  methods: {
    openSidebar() {
      this.$store.commit(UI_SHOW_SIDEBAR)
    },
    expandNotice(idx) {
      if (this.selected === idx) {
        this.selected = null
      } else {
        this.selected = idx
      }
    },
    loadAnnouncements() {
      const { currentPage, noticesPerPage } = this
      this.$store.dispatch(STORE_ANNOUNCEMENT_GET_LIST, {
        page: currentPage,
        pageRow: noticesPerPage
      })
    },
    paginate(page) {
      this.currentPage = page
      this.loadAnnouncements()
    },
    closeListMenu() {
      this.showListMenu = false
    },
    toggleListMenu() {
      this.showListMenu = !this.showListMenu
    }
  }
}
</script>
<style src="@/assets/css/page_customer.css" scoped></style>
<style lang="scss" scoped>
h1 {
  font-size: 36px;
  margin-top: 94px;
  text-align: center;
}
</style>
